import axios from "axios";

const TealiumApiBaseURL = "https://visitor-service.tealiumiq.com";

const unauthorizedStatusCode = [400, 401, 403];

export const getAllTealiumAudienceStreamData = async (account, profile) => {
    try {
        const url = new URL(`${TealiumApiBaseURL}/datacloudprofiledefinitions/${account}/${profile}`);

        let config = {
            method: "get",
            url: url,
        };
        const result = await axios.request(config);
        return result.data;
    } catch (error) {
        if(unauthorizedStatusCode.includes(error?.response?.status) && error?.response?.data?.message?.includes(`timestamp check failed`)) {
            window.localStorage.clear();
            window.location.reload()
        }
        throw error?.response?.data;
    }
};
